import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Col, Row, Table } from '@themesberg/react-bootstrap'
import React from 'react'
import PaymentProvidersList from '../../../../components/PaymentProvidersList'
import Preloader from '../../../../components/Preloader'
import { toast } from '../../../../components/Toast'
import useWithdraw from '../hooks/useWithdraw'

const Withdraw = ({
  createTenantData,
  setCreateTenantData,
  setSelectedTab,
  selectedTab
}) => {
  const {
    loading,
    data,
    tenantId,
    createTenant,
    editTenant
  } = useWithdraw(selectedTab)

  return (
    <>
      {
        loading
          ? <Preloader />
          : (
            <>
              <Row>
                <Col>
                  <PaymentProvidersList
                    data={data}
                    createTenantData={createTenantData}
                    setCreateTenantData={setCreateTenantData}
                    selectedTab={selectedTab}
                    tenant
                  />
                </Col>
                <Col>
                  <Table
                    bordered
                    striped
                    responsive
                    hover
                    size='sm'
                    className='text-center'
                  >
                    <thead className='thead-dark'>
                      <tr>
                        <th>Provider</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {typeof (createTenantData.withdrawMethods) === 'object' && !!createTenantData.withdrawMethods.length && createTenantData.withdrawMethods.map(({ name, paymentProviderId }) => {
                        return (
                          <tr key={name}>
                            <td>{name}</td>
                            <td>
                              <Button
                                variant='danger'
                                size='sm'
                                onClick={() => {
                                  setCreateTenantData({
                                    ...createTenantData,
                                    withdrawMethods: createTenantData.withdrawMethods.filter(item => item.paymentProviderId !== paymentProviderId)
                                  })
                                }}
                              >
                                <FontAwesomeIcon icon={faTrash} />
                              </Button>
                            </td>
                          </tr>
                        )
                      })}
                      {(!createTenantData || !createTenantData.withdrawMethods || createTenantData.withdrawMethods.length === 0) &&
                        (
                          <tr>
                            <td
                              colSpan={2}
                              className='text-danger text-center'
                            >
                              No data found
                            </td>
                          </tr>
                        )}
                    </tbody>
                  </Table>
                </Col>
              </Row>
              <div className='d-flex justify-content-between mt-3'>
                <Button
                  onClick={() => setSelectedTab('deposit')}
                  variant='outline-warning'
                >
                  Previous
                </Button>

                <Button
                  onClick={() => {
                    if (createTenantData.withdrawMethods.length) {
                      tenantId
                        ? editTenant({
                          createTenantData,
                          val: true,
                          tenantId
                        })
                        : createTenant(createTenantData, setCreateTenantData, setSelectedTab)
                    } else {
                      toast('Please Add at least one Withdraw Method', 'error')
                    }
                  }}
                  variant='outline-success'
                >
                  Submit
                </Button>
              </div>
            </>
            )

}
    </>
  )
}

export default Withdraw
